import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="pti-container py-12 max-w-3xl" data-testid="about-page">
      <span className="text-[11px] uppercase tracking-widest font-bold text-pti-red">About</span>
      <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">A premium home for the people building the future.</h1>
      <p className="text-lg text-gray-700 mt-6 leading-relaxed">
        PictureThisInk is a modern creator media platform covering technology, AI, creative business, design,
        innovation, startups, gaming, digital culture, lifestyle, and the inspiring people shaping what comes next.
      </p>
      <p className="text-gray-700 mt-4 leading-relaxed">
        We mix original editorial reporting, a vertical Shorts experience, a curated live news wire (InkWire),
        and a premium games hub (Arcade) — all in one clean, advertiser-friendly, human-first place.
        Everything you see is manually reviewed before it goes live.
      </p>

      <div className="grid sm:grid-cols-2 gap-6 mt-10">
        {[
          ["Original & human", "Real bylines, real creators, and editorial standards. No copied AI slop, no hidden ads."],
          ["Advertiser-safe", "Every article, Short, comment, and ad is reviewed against clear brand-safety rules before publishing."],
          ["Accessible by design", "Built toward WCAG 2.2 AA: full keyboard support, captions, contrast, and reduced-motion respect."],
          ["General audience, 18+", "PictureThisInk is not directed to children. You must be 18+ to create, publish, comment, or advertise."],
        ].map(([t, d]) => (
          <div key={t} className="border border-gray-200 p-6">
            <h3 className="font-display text-xl font-bold">{t}</h3>
            <p className="text-gray-600 mt-2 text-sm leading-relaxed">{d}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 flex gap-3">
        <Link to="/register" className="bg-pti-red text-white px-6 py-3 font-bold hover:bg-pti-redhover transition-colors">Become a creator</Link>
        <Link to="/advertise" className="border border-pti-black px-6 py-3 font-bold hover:bg-pti-black hover:text-white transition-colors">Advertise with us</Link>
      </div>

      <p className="mt-12 pt-6 border-t border-gray-200 text-sm text-gray-500 leading-relaxed" data-testid="about-powered-by">
        PictureThisInk is powered by <a href="https://www.mishertech.com" target="_blank" rel="noopener noreferrer" aria-label="Visit MisherTech" className="font-semibold text-pti-black hover:text-pti-red transition-colors">MisherTech</a>, a technology company focused on software development, intellectual property, and digital media.
      </p>
    </div>
  );
}
